
/**
 * Utilitários para formatação de datas sem problemas de timezone
 */

/**
 * Converte uma data para string local sem conversão de timezone
 */
export const dateToLocalString = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Cria uma data a partir de string no timezone local
 */
export const localStringToDate = (dateString: string): Date => {
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
};

/**
 * Verifica se uma data está no range especificado
 */
export const isDateInRange = (dateString: string, startDate: Date, endDate: Date): boolean => {
  const startString = dateToLocalString(startDate);
  const endString = dateToLocalString(endDate);
  return dateString >= startString && dateString <= endString;
};

/**
 * Formata uma data para exibição em português
 */
export const formatDateForDisplay = (dateString: string): string => {
  if (!dateString) return '';
  
  const [year, month, day] = dateString.split('-').map(Number);
  if (!year || !month || !day) return dateString;
  
  const date = new Date(year, month - 1, day);
  return date.toLocaleDateString('pt-BR');
};

/**
 * Obtém a data de hoje como string local
 */
export const getTodayString = (): string => {
  return dateToLocalString(new Date());
};
